import React, { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { HiOutlineMenuAlt4, HiX } from "react-icons/hi";
import { FiArrowRight } from "react-icons/fi";
import brand from "../content/brand";

const links = [
  { to: "/", label: "Home", end: true },
  { to: "/services", label: "Services" },
  { to: "/work", label: "Work" },
  { to: "/about", label: "About" },
  { to: "/contact", label: "Contact" }
];

const Header = () => {
  const [open, setOpen] = useState(false);
  return (
    <header className="masthead">
      <div className="shell row">
        <Link to="/" className="mark mark--logo" onClick={() => setOpen(false)} aria-label={brand.name}>
          <img src="/brand/btcruka-logo.png" alt={brand.name} className="brand-logo" />
        </Link>

        <nav>
          {links.map((l) => (
            <NavLink key={l.to} to={l.to} end={l.end} className={({ isActive }) => isActive ? "is-on" : ""}>
              {l.label}
            </NavLink>
          ))}
        </nav>

        <div className="extras">
          <Link to="/contact" className="btn btn--mint">
            Start engagement <FiArrowRight />
          </Link>
          <button className="toggle" aria-label="Toggle menu" onClick={() => setOpen((v) => !v)}>
            {open ? <HiX /> : <HiOutlineMenuAlt4 />}
          </button>
        </div>
      </div>

      {open && (
        <div className="mobile-nav">
          {links.map((l) => (
            <NavLink key={l.to} to={l.to} end={l.end} onClick={() => setOpen(false)}>
              {l.label}
            </NavLink>
          ))}
          <Link to="/contact" className="btn btn--mint" onClick={() => setOpen(false)} style={{ marginTop: "1rem", width: "100%", justifyContent: "center" }}>
            Start engagement <FiArrowRight />
          </Link>
        </div>
      )}
    </header>
  );
};

export default Header;
